<p-dialog [(visible)]="selectViewOrder" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '75vw', height: '80vh' }" [closable]="false">
	<ng-template pTemplate="header">
		<div class="d-flex display-2">Your Order</div>
		<div class="display-2 ms-auto">{{ kioskService.activeOrder.value.total | currency }}</div>
	</ng-template>
	<p-divider></p-divider>
	<p-scrollPanel styleClass="w-100 h-100">
		<div class="d-flex flex-column">
			<ng-container *ngFor="let item of kioskService.activeOrder.value.seats[0].items; let parentIndex = index">
				<div class="p-grid display-5">
					<div class="col-1">
						{{ item.quantity }}
					</div>
					<div class="col-6">
						{{ item.name }}
					</div>
					<div class="col-2 d-flex">
						<div class="ms-auto p-text-right">
							{{ item.price | currency }}
						</div>
					</div>
					<div class="col-3 d-flex justify-content-end">
						<div class="my-auto ms-auto">
							<p-selectButton [options]="itemFunctionButtonOptions" optionLabel="icon" (onOptionClick)="itemFunctionCommand($event, parentIndex)">
								<ng-template let-item>
									<fa-icon
										[icon]="[item.faPrefix, item.faIcon]"
										size="2x"
										[ngStyle]="{ color: item.value === 'remove' ? '#D3302F' : item.value === 'edit' ? '#0E7ABC' : '#5E8F32' }"
									></fa-icon>
								</ng-template>
							</p-selectButton>
						</div>
					</div>
				</div>
				<ng-container *ngFor="let modifier of item.modifiers; let modifierIndex = index">
					<div class="ms-3 p-grid display-6">
						<div class="col-1">
							{{ modifier.qty }}
						</div>
						<div class="col-6">
							{{ modifier.name }}
						</div>
						<div class="col-2 ms-auto p-text-right">
							<span *ngIf="modifier.price !== 0">
								{{ modifier.price | currency }}
							</span>
						</div>
						<div class="col-3"></div>
					</div>
				</ng-container>
			</ng-container>
		</div>
	</p-scrollPanel>

	<ng-template pTemplate="footer">
		<div class="d-flex" style="height: 10vh">
			<div pRipple class="flex-fill p-button p-button-danger p-button-raised w-100 h-100 me-2" (click)="selectViewOrderChange.emit(false)">
				<div class="d-flex mx-auto display-6">
					<fa-icon [icon]="['far', 'times-circle']" size="lg" class="ms-1 me-2"></fa-icon>
					Continue Ordering
				</div>
			</div>
			<div
				pRipple
				class="flex-fill p-button p-button-success p-button-raised w-100 h-100 ms-2"
				(click)="startCheckoutChange.emit(true); selectViewOrderChange.emit(false)"
			>
				<div class="d-flex mx-auto display-6">
					<fa-icon [icon]="['far', 'shopping-cart']" size="lg" class="ms-1 me-2"></fa-icon>
					Checkout {{ kioskService.activeOrder.value.total | currency }}
				</div>
			</div>
		</div>
	</ng-template>
</p-dialog>
